/* Gorra a precio especial en el carrito (3 nov 2026). El tema publica window.cassavaGorraRegalo desde el metacampo custom.gorra_regalo:
   start/end en segundos, goal y precio en centavos, gorra (id del producto real), excluir (ids que no cuentan para la meta),
   sin_lealtad (true = no se junta con el Plan de lealtad) y regalos [{ id, pagada, nombre }] (variante a precio especial y su variante real).
   La meta se mide con los precios ya rebajados por descuentos automáticos, sin envío y sin códigos, que se ponen al pagar. */
(() => {
  const cfg = window.cassavaGorraRegalo;
  if (!cfg || !Array.isArray(cfg.regalos) || !cfg.regalos.length) return;

  const KEY_NO = 'crbGorraNo';
  const KEY_BAJO = 'crbGorraBajo';
  const excluir = (cfg.excluir || []).map(Number);
  const agotados = new Set();
  let ultimo = null;
  let ocupado = false;
  let otra = false;
  let espera = null;

  function guardado(key) { try { return localStorage.getItem(key); } catch (e) { return null; } }
  function guarda(key, valor) {
    try {
      if (valor) localStorage.setItem(key, valor);
      else localStorage.removeItem(key);
    } catch (e) {}
  }

  function activa() {
    const now = Date.now() / 1000;
    return now >= Number(cfg.start) && now <= Number(cfg.end);
  }

  function dinero(cents) {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'MXN',
      minimumFractionDigits: cents % 100 ? 2 : 0,
      maximumFractionDigits: 2
    }).format(cents / 100);
  }

  const especial = dinero(Number(cfg.precio));
  const regaloDe = (item) => cfg.regalos.find((r) => r.id === item.variant_id);
  const esGorra = (item) => item.product_id === Number(cfg.gorra);

  function lee(cart) {
    const lineas = cart.items.filter(regaloDe);
    const pagadas = cart.items.filter(esGorra);
    const base = cart.items.reduce((suma, item) => (
      regaloDe(item) || esGorra(item) || excluir.includes(item.product_id) ? suma : suma + item.final_line_price
    ), 0);
    const lealtad = Boolean(cfg.sin_lealtad) && cart.items.some((item) => (item.discounts || []).some((d) => /^Plan de lealtad/i.test(d.title || '')));
    return { lineas, pagadas, base, lealtad, gana: activa() && base >= Number(cfg.goal) && !lealtad };
  }

  // Devuelve los cambios que necesita el carrito ({ variante: cantidad }) o null si ya está bien.
  function cambios(cart) {
    const { lineas, pagadas, base, lealtad, gana } = lee(cart);
    const updates = {};

    if (!gana) {
      if (!lineas.length) return null;
      lineas.forEach((l) => { updates[l.variant_id] = 0; });
      if (activa() && !lealtad && base > 0) {
        const regalo = regaloDe(lineas[0]);
        const yaPagada = pagadas.find((p) => p.variant_id === regalo.pagada);
        updates[regalo.pagada] = (yaPagada ? yaPagada.quantity : 0) + 1;
        guarda(KEY_BAJO, cart.token);
      }
      return updates;
    }

    if (lineas.length) {
      const [primera, ...sobran] = lineas;
      if (primera.quantity === 1 && !sobran.length) return null;
      updates[primera.variant_id] = 1;
      sobran.forEach((l) => { updates[l.variant_id] = 0; });
      return updates;
    }

    if (guardado(KEY_NO) === cart.token) return null;
    const disponibles = cfg.regalos.filter((r) => !agotados.has(r.id));
    const pagada = pagadas.find((p) => disponibles.some((r) => r.pagada === p.variant_id));
    const regalo = pagada ? disponibles.find((r) => r.pagada === pagada.variant_id) : disponibles[0];
    if (!regalo) return null;
    updates[regalo.id] = 1;
    if (pagada) updates[pagada.variant_id] = pagada.quantity - 1;
    return updates;
  }

  function secciones() {
    const lista = [];
    const drawer = document.querySelector('cart-drawer');
    const items = document.querySelector('cart-items');
    if (drawer) drawer.getSectionsToRender().forEach((s) => lista.push({ id: s.id, section: s.id, selector: s.selector, de: drawer }));
    if (items) items.getSectionsToRender().forEach((s) => lista.push({ ...s, de: items, pagina: true }));
    return lista;
  }

  // Redibuja el carrito sin abrir el cajón (renderContents lo abre, y esto también corre al cargar la página).
  function redibuja(lista, data) {
    lista.forEach((s) => {
      const html = data.sections && data.sections[s.section];
      if (!html) return;
      const caja = document.getElementById(s.id);
      const el = s.pagina
        ? (caja && (caja.querySelector(s.selector) || caja))
        : (s.selector ? document.querySelector(s.selector) : caja);
      if (el) el.innerHTML = s.de.getSectionInnerHTML(html, s.selector);
    });
    const drawer = document.querySelector('cart-drawer');
    const overlay = drawer && drawer.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
  }

  async function aplica(updates) {
    const lista = secciones();
    const res = await fetch(`${window.routes?.cart_update_url || '/cart/update'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        updates,
        sections: [...new Set(lista.map((s) => s.section))],
        sections_url: window.location.pathname
      })
    });
    if (!res.ok) throw new Error(String(res.status));
    const data = await res.json();
    redibuja(lista, data);
    document.dispatchEvent(new CustomEvent('cassava:cart-changed', { detail: { cart: data } }));
    return data;
  }

  function pinta() {
    const cajas = document.querySelectorAll('[data-crb-gorra-aviso]');
    if (!cajas.length || !ultimo) return;
    const { lineas, pagadas, base, lealtad } = lee(ultimo);
    const on = activa();
    const falta = Math.max(Number(cfg.goal) - base, 0);
    let html = '';

    if (lineas.length) {
      const actual = regaloDe(lineas[0]);
      const opciones = cfg.regalos.map((r) => (
        `<button type="button" class="crb-gr__btn" data-crb-gorra-cambia="${r.id}" aria-pressed="${r.id === actual.id}"${agotados.has(r.id) ? ' disabled' : ''}>${r.nombre}</button>`
      )).join('');
      html = `<p><strong>Tu gorra por ${especial} ya está en tu carrito.</strong> Elige tu diseño:</p><div class="crb-gr__opts">${opciones}</div>`;
    } else if (on && lealtad) {
      html = `<p>Tu descuento del Plan de lealtad no se junta con la gorra por ${especial}.</p>`;
    } else if (on && base >= Number(cfg.goal) && guardado(KEY_NO) === ultimo.token) {
      html = `<p>Quitaste tu gorra por ${especial}.</p><div class="crb-gr__opts"><button type="button" class="crb-gr__btn" data-crb-gorra-recupera>Quiero mi gorra</button></div>`;
    } else if (on && pagadas.length && guardado(KEY_BAJO) === ultimo.token) {
      html = `<p><strong>Tu pedido bajó de ${dinero(Number(cfg.goal))}:</strong> tu gorra ya no cuesta ${especial}, ahora cuesta ${dinero(pagadas[0].final_price)}. Si no la quieres, quítala del carrito. Te faltan ${dinero(falta)} para que vuelva a costar ${especial}.</p>`;
    } else if (on && base > 0 && falta > 0) {
      html = `<p>Te faltan <strong>${dinero(falta)}</strong> para llevarte tu gorra por ${especial}.</p>`;
    }

    cajas.forEach((caja) => {
      caja.innerHTML = html;
      caja.hidden = !html;
    });
  }

  async function sincroniza() {
    if (ocupado) { otra = true; return; }
    ocupado = true;
    try {
      let cart = await fetch(`${window.routes?.cart_url || '/cart'}.js`, { cache: 'no-store' }).then((r) => r.json());
      const updates = cambios(cart);
      if (updates) {
        cart = await aplica(updates);
        // Si no había existencia, Shopify no agrega la variante: se prueba con el otro diseño.
        Object.keys(updates).forEach((id) => {
          const regalo = cfg.regalos.find((r) => String(r.id) === id);
          if (regalo && updates[id] > 0 && !cart.items.some((i) => i.variant_id === regalo.id)) {
            agotados.add(regalo.id);
            otra = true;
          }
        });
      }
      ultimo = cart;
      if (!lee(cart).pagadas.length || lee(cart).gana) guarda(KEY_BAJO, null);
      pinta();
    } catch (e) {
      // Sin gorra no se bloquea la compra: se vuelve a revisar en el siguiente cambio del carrito.
    } finally {
      ocupado = false;
      if (otra) { otra = false; sincroniza(); }
    }
  }

  function pide() {
    clearTimeout(espera);
    espera = setTimeout(sincroniza, 200);
  }

  document.addEventListener('click', (event) => {
    const el = event.target.closest && event.target.closest('[data-crb-regalo] cart-remove-button, [data-crb-gorra-cambia], [data-crb-gorra-recupera]');
    if (!el || !ultimo) return;
    if (el.matches('cart-remove-button')) {
      guarda(KEY_NO, ultimo.token);
    } else if (el.hasAttribute('data-crb-gorra-recupera')) {
      guarda(KEY_NO, null);
      pide();
    } else {
      const nuevo = Number(el.dataset.crbGorraCambia);
      const linea = lee(ultimo).lineas[0];
      if (!linea || linea.variant_id === nuevo) return;
      el.disabled = true;
      aplica({ [linea.variant_id]: 0, [nuevo]: 1 }).catch(() => {}).finally(pide);
    }
  }, true);

  document.addEventListener('cassava:cart-changed', pide);
  window.addEventListener('pageshow', pide);
  document.addEventListener('shopify:section:load', pide);

  // El carrito se redibuja seguido: si el aviso vuelve vacío, se llena otra vez.
  new MutationObserver(() => {
    if (document.querySelector('[data-crb-gorra-aviso]:empty')) pinta();
  }).observe(document.documentElement, { childList: true, subtree: true });

  pide();
})();
